import firebase from "../../firebase";

export const getGameById = async (collection, id) => {
    const result = await firebase.db.collection(collection).doc(id).get();
    return result.data();
}